import { useEnvironmentModeContext } from '../../context/EnvironmentModeContext';

import { Appbar } from '@asphalt-react/appbar';
import { Button } from '@asphalt-react/button';
import { GoPay, Logo } from '@asphalt-react/logo';
import { ToggleSwitch } from '@asphalt-react/toggle-switch';

export const Header = () => {
  const { isDevMode, toggleDevMode } = useEnvironmentModeContext();

  return (
    <Appbar
      head={<Logo product="gopay" symbol={<GoPay />} size="m" />}
      tail={
        <Button tertiary brand size="xs">
          <label className="my-auto mx-5">Dev Mode</label>
          <ToggleSwitch on={isDevMode} onToggle={toggleDevMode} />
        </Button>
      }
    ></Appbar>
  );
};
